import { Box, FormLabel, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import type { CommonProps, DateRangeFilterProps } from './types';

export const CourseFilter = ({ value, onChange }: CommonProps) => (
  <Box sx={{ flex: 1, width: '100%' }}>
    <FormLabel>Busque o curso</FormLabel>
    <TextField fullWidth value={value} onChange={onChange} />
  </Box>
);

export const ColaboradorFilter = ({ value, onChange }: CommonProps) => (
  <Box sx={{ flex: 1, width: '100%' }}>
    <FormLabel>Busque o colaborador</FormLabel>
    <TextField fullWidth value={value} onChange={onChange} />
  </Box>
);

export const DateRangeFilter = ({
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
}: DateRangeFilterProps) => (
  <>
    <Box sx={{ minWidth: { xs: '100%', md: 200 } }}>
      <FormLabel>Data inicial</FormLabel>
      <DatePicker
        value={dateFrom}
        onChange={onDateFromChange}
        slotProps={{ textField: { fullWidth: true } }}
      />
    </Box>
    <Box sx={{ minWidth: { xs: '100%', md: 200 } }}>
      <FormLabel>Data final</FormLabel>
      <DatePicker
        value={dateTo}
        onChange={onDateToChange}
        slotProps={{ textField: { fullWidth: true } }}
      />
    </Box>
  </>
);
